import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { calculateTrainAndShuttlePricesFromBooking, updatePaymentItemsForCancelBooking } from "../../../Lib/Utils/validationUtil";
import { cancelBookingTree } from "../../../Orchestrator/ConstantTree/CancelBookingPage/CancelBookingTree";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookingResponse, ISelectedPassengerForCancelIds, PassengerPriceDetails } from "../../../Orchestrator/Types/Index";


export class MainOutBoundCheckAction extends BaseAction<void, {
    allOutBoundFulFilledPass: PassengerPriceDetails[],
    passengerIds?: string[],
    booking: IBookingResponse,
    outboundChecked: boolean,
    inboundChecked: boolean,
    selectedPassengerForCancel: ISelectedPassengerForCancelIds[],
    selectedPassengerForCancelInBound: ISelectedPassengerForCancelIds[]
}> {
    async run(): Promise<void | null> {
        try {
            const { allOutBoundFulFilledPass, passengerIds, booking, outboundChecked, inboundChecked } = this.params!;
            if (outboundChecked == true) {
                let targetPassengerIds: string[] = [];
                if (passengerIds && passengerIds.length > 0) {
                    targetPassengerIds = passengerIds;
                    updateRecoilState("selectedPassengerForCancelAtom", passengerIds);
                } else {
                    targetPassengerIds = allOutBoundFulFilledPass.map((d) => d.pId.toString());
                    updateRecoilState("selectedPassengerForCancelAtom", targetPassengerIds);
                }
                
                // Calculate train and shuttle prices from booking data for selected passengers
                const combinedPriceDetails = calculateTrainAndShuttlePricesFromBooking(
                    booking,
                    targetPassengerIds,
                    TripTypeEnum.OUT_BOUND
                );
                
                const response = updatePaymentItemsForCancelBooking(combinedPriceDetails, "paymentOutBoundItemsDetailsAtom");
                updateRecoilState("paymentOutBoundItemsDetailsAtom", response);
                _eventBus.emit({
                    eventName: cancelBookingTree.CancelBooking.Init,
                    data: {
                        booking: booking,
                        filteredOutboundData: targetPassengerIds,
                        filteredInboundData: [],
                        outboundChecked: true,
                        inboundChecked: inboundChecked,
                    }
                });
            }
            else {
                updateRecoilState("selectedPassengerForCancelAtom", []);
                const response = updatePaymentItemsForCancelBooking([], "paymentOutBoundItemsDetailsAtom");
                updateRecoilState("paymentOutBoundItemsDetailsAtom", response);
                _eventBus.emit({
                    eventName: cancelBookingTree.CancelBooking.Init,
                    data: {
                        booking: booking,
                        filteredOutboundData: [],
                        filteredInboundData: [],
                        outboundChecked: false,
                        inboundChecked: inboundChecked
                    }
                });
            }

        } catch (error) {
            console.error("Error in PassengerOutboundCheck action.:", error);
        }
    }
}

export const mainOutBoundCheckAction = new MainOutBoundCheckAction();